import { useTranslation } from "react-i18next";
import { Close } from "@dreamhub/designsystem/icons";
import { Button } from "@/components/ui/button";
import { IconButton } from "@/components/ui/icon-button";
import ToastBody from "@/components/ui/toast-body";
import { TRANSLATION_KEY } from "@/components/global/Chat/components/dreamerReports/consts";

interface ScheduledReportToastProps {
  message: string;
  onManageReports: () => void;
  onDismiss: () => void;
}

/** Confirms a schedule was set, with a way to the Reports tab from the toast. */
export const ScheduledReportToast: React.FC<ScheduledReportToastProps> = ({
  message,
  onManageReports,
  onDismiss
}) => {
  const { t } = useTranslation();

  return (
    <ToastBody
      title={message}
      actions={
        <>
          <Button
            variant="secondary"
            onClick={() => {
              onManageReports();
              onDismiss();
            }}
            data-test="scheduled-toast-manage-reports"
          >
            {t(`${TRANSLATION_KEY}.save.manageReports`)}
          </Button>
          <IconButton
            variant="iconNoBg"
            iconColor="secondary"
            size="md"
            onClick={onDismiss}
            aria-label={t("close")}
          >
            <Close />
          </IconButton>
        </>
      }
    />
  );
};
